<template lang="pug">
    div
      .d-flex.float-right
        b-spinner.mb-3.text-sm(variant="primary", v-if="loading_message", style="width: 1.8rem; height: 1.8rem;")
      b-row.mb-1(v-if="this.message.text")
        b-col
          span.text-md Mensaje:
        b-col
          span.overflow-x.scrollable-area.wrapping.text-sm(class="badge badge-soft-secondary") {{ this.message.text }}
      b-row.mb-1(v-if="message_id")
        b-col
          span.text-md ID del mensaje:
        b-col
          span.text-sm(class="badge badge-soft-secondary") {{ message_id }}
      b-row.mb-1(v-if="this.message.user_id")
        b-col
          span.text-md ID del usuario:
        b-col
          span.text-sm(class="badge badge-soft-secondary") {{ this.message.user_id }}
      b-row.mb-1(v-if="this.message.conversation_id")
        b-col
          span.text-md ID de conversación:
        b-col
          span.text-sm(class="badge badge-soft-secondary") {{ this.message.conversation_id }}
      b-row.mb-1(v-if="this.message.thread_id")
        b-col
          span.text-md ID de hilo (ventana de 24 horas):
        b-col
          span.text-sm(class="badge badge-soft-secondary") {{ this.message.thread_id }}
      b-row.mb-1(v-if="this.message.external_id")
        b-col
          span.text-md ID externo:
        b-col
          span.text-sm.overflow-x.scrollable-area.wrapping(class='badge badge-soft-secondary') 2{{ this.message.external_id }}
      b-row.mb-1(v-if="this.message.date")
        b-col
          span.w-5.text-md Fecha y hora:
        b-col
          span.text-sm(class="badge badge-soft-secondary") {{ putHourWithTimezone(this.message.date) }}
      b-row.mb-1(v-if="this.message.campaign")
        b-col
          span.text-md ID de campaña:
        b-col
          span.text-sm(class="badge badge-soft-secondary") {{ this.message.campaign }}
      b-row.mb-1(v-if="this.message.author")
        b-col
          span.text-md Autor:
        b-col
          span.text-sm(class="badge badge-soft-secondary") {{ this.message.author.charAt(0).toUpperCase() + this.message.author.slice(1) }}
      b-row.mb-1(v-if="this.message.adminName")
        b-col
          span.text-md Nombre del administrador:
        b-col
          span.text-sm(class="badge badge-soft-secondary") {{ this.message.adminName }}
      b-row.mb-1(v-if="this.message.response_type")
        b-col
          span.text-md Tipo de respuesta:
        b-col
          span.text-sm(class="badge badge-soft-secondary") {{ this.message.response_type }}
      b-row.mb-1(v-if="this.message.status")
        b-col
          span.text-md Estatus:
        b-col
          span.text-sm(:class="getStatusColorToInfo(this.message.status)") {{ getSpanishMessageStatus(this.message.status) }}
      // Temporally without condition because of tests
      b-row.mb-1
        b-col
          span.text-md Respondido con:
        b-col
          span.text-sm(class="badge badge-soft-secondary") {{ this.message.responded_with || 'N/A' }}
      b-row.mb-1(v-if="this.message.error")
        b-col
          span.text-md.text-danger Error:
        b-col
          span.text-sm.overflow-x.scrollable-area.wrapping.text-danger(class="badge badge-soft-danger") {{ this.message.error }}
      b-row.mb-1(v-if="this.message.sent_at")
        b-col
          span.text-md Enviado:
        b-col
          span.text-sm(class="badge badge-soft-secondary") {{ putHourWithTimezone(this.message.sent_at, 'seconds') }}
      b-row.mb-1(v-if="this.message.delivered_at")
        b-col
          span.text-md Entregado:
        b-col
          span.text-sm(class="badge badge-soft-secondary") {{ putHourWithTimezone(this.message.delivered_at, 'seconds') }}
      b-row.mb-1(v-if="this.message.read_at")
        b-col
          span.text-md Leído:
        b-col
          span.text-sm(class="badge badge-soft-secondary") {{ putHourWithTimezone(this.message.read_at, 'seconds') }}
      b-row.mb-1(v-if="this.message.hsm_name")
        b-col
          span.text-md ID plantilla de WhatsApp:
        b-col
          span.text-sm(class="badge badge-soft-secondary") {{ this.message.hsm_name }}

      b-row.d-flex.mt-4(v-if="this.message.response_info  && JSON.parse(this.message.response_info)")
        b-col
          b-form-group
            .d-flex.align-items-center.pointer.hover-primary(v-b-toggle.clickResponse)
              span Información de respuesta
              chevron-down-icon.ml-2.icon-md.collapse-icon
            b-collapse.mt-3(id='clickResponse')
              b-row.mb-1
                b-col
                  json-view(:value="JSON.parse(this.message.response_info)", copyable, expanded=true)

      b-row.d-flex.mt-4(v-if="this.message.trace && this.message.trace.length")
        b-col
          b-form-group
            .d-flex.align-items-center.pointer.hover-primary(v-b-toggle.clickMe)
              span Información de rastreo
              chevron-down-icon.ml-2.icon-md.collapse-icon
            b-collapse.mt-3(id='clickMe')
              b-row(v-for="(trace, index) in (this.message.trace)" :key="index")
                b-col
                  b-row.mb-1(v-if="trace.event")
                    b-col
                      span.text-md Evento:
                    b-col
                      b-badge.text-sm(:class="getStatusColorToInfo(trace.event)") {{ trace.event }}
                  b-row.mb-1(v-if="trace.title")
                    b-col
                      span.text-md Titulo:
                    b-col
                      b-badge.text-sm.overflow-x.scrollable-area(:class="getStatusColorToInfo(trace.event)") {{ trace.title }}
                  b-row.mb-1(v-if="trace.date")
                    b-col
                      span.text-md Fecha:
                    b-col
                      span.text-sm(class="badge badge-soft-secondary") {{ putHourWithTimezone(trace.date, 'minutes') }}
                  b-row.mb-1(v-if="trace.info")
                    b-col
                      span.text-md Información:
                      json-view(:value="JSON.parse(trace.info)", copyable, expanded=true)

      b-row(v-if="this.message.message_details")
        b-col
          b-row.mb-1(v-if="this.message.message_details.assignation_method")
            b-col
              span.text-md Método de asignación:
            b-col
              span.text-sm(class="badge badge-soft-secondary") {{ this.message.message_details.assignation_method }}
          b-row.mb-1(v-if="this.message.message_details.max_cases_to_assign")
            b-col
              span.text-md Máximo número de casos por asesor:
            b-col
              span.text-sm(class="badge badge-soft-secondary") {{ this.message.message_details.max_cases_to_assign }}
          b-row.mb-1(v-if="this.message.message_details.group")
            b-col
              span.text-md Grupo:
            b-col
              span.text-sm(class="badge badge-soft-secondary") {{ this.message.message_details.group.name }}
          b-row.mb-1(v-if="this.message.message_details.case_queue_type")
            b-col
              span.text-md Tipo de queue:
            b-col
              span.text-sm(class="badge badge-soft-secondary") {{this.message.message_details.case_queue_type == "on_demand" ? "On demand" : "Normal" }}
          b-row.mb-1(v-if="this.message.message_details.case_queue_sort")
            b-col
              span.text-md Tipo de ordenamiento:
            b-col
              span.text-sm(class="badge badge-soft-secondary") {{this.message.message_details.case_queue_sort == "number_of_cases" ? "Por número de casos abiertos" : "Por hora de último caso asignado" }}
          b-row.mb-1(v-if="this.message.message_details.details")
            b-col
              span.text-md Descripción de nota:
            b-col
              span.text-sm.overflow-x.scrollable-area.wrapping(class="badge badge-soft-secondary") {{this.message.message_details.details }}
          div(v-if="this.message.message_details.admin_assigned")
            h5.my-3 Asignación de caso
            b-row.mb-1
              b-col
                span.text-md Agente asignado:
              b-col
                span.text-sm(class="badge badge-soft-secondary") {{ this.message.message_details.admin_assigned.name || 'Sin nombre' }}
            b-row.mb-1
              b-col
                span.text-md Estatus:
              b-col
                span.text-sm(class="badge badge-soft-secondary") {{ this.message.message_details.admin_assigned.status || 'Sin status' }}
          div(v-if="this.message.message_details.available_admins && this.message.message_details.available_admins.length")
            b-row.mb-1.align-items-center
              b-col
                span.text-md.break Agentes disponibles durante la asignación:
              b-col
                span.text-sm(class="badge badge-soft-secondary") {{ this.message.message_details.available_admins.length }}
              div(v-for="(admin, index) in this.message.message_details.available_admins")
                span.text-sm(:id="admin._id" style="display: inline-block") ● {{admin.name}}  (Último caso atendido: {{$moment(admin.last_case_assigned_time).format("DD MMM HH:mm")}})
                span.text-sm(v-if="admin.open_cases || admin.open_cases === 0") [{{admin.open_cases}} casos abiertos]
                b-badge.ml-2(style="display: inline-block" variant="secondary" pill) {{admin.status}}
                b-badge.ml-2(v-if="index === 0" style="display: inline-block" variant="success" ) Asignado
                b-tooltip(:target="admin._id" :title="admin.email" placement="top")
          div(v-if="this.message.message_details.available_bussy_admins && this.message.message_details.available_bussy_admins.length")
            b-row.mb-1.align-items-center
              b-col
                span.text-md.break Agentes ocupados durante la asignación:
              b-col
                span.text-sm(class="badge badge-soft-secondary") {{ this.message.message_details.available_bussy_admins.length }}
            b-row
              b-col
                div(v-for="(admin, index) in this.message.message_details.available_bussy_admins")
                  span.text-sm(:id="admin._id" style="display: inline-block") ● {{admin.name || 'moi'}}  (Último caso atendido: {{$moment(admin.last_case_assigned_time || new Date()).format("DD MMM HH:mm")}})
                  b-badge.ml-2(style="display: inline-block" variant="secondary" pill) {{admin.status || 'available'}}
                  b-badge.ml-2(:i='admin.open_cases' style="display: inline-block" variant="success" pill) {{admin.open_cases || 'open'}}
                  b-tooltip(:target="admin._id" :title="admin.email || 'mail'" placement="top")
</template>

<script>
import JsonViewer from 'vue-json-viewer'
import _ from 'lodash'
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      message: {},
      loading_message: true,
    }
  },
  props: {
    message_id: String,
    timezone: {
      type: String,
      default: 'America/Mexico_City'
    },
  },
  computed: {
  },
  methods: {
    ...mapActions(['conversation/getMessageDetails']),
    putHourWithTimezone(messageDate, format = 'seconds') {
      if (messageDate && this.timezone && format === 'seconds') {
        return this.$moment(messageDate).tz(this.timezone).format('DD MMM hh:mm:ss A')
      }

      if (messageDate && this.timezone && format === 'minutes') {
        return this.$moment(messageDate).tz(this.timezone).format('DD MMM HH:mm A')
      }
    },
    getStatusColorToTextError(status) {
      status = status.toLowerCase()

      if (status == 'failed') {
        return 'text-danger'
      }
    },
    getStatusColorToInfo(status) {
      status = status.toLowerCase()

      const color = {
        read: 'badge badge-soft-success',
        delivered: 'badge badge-soft-warning',
        failed: 'badge badge-soft-danger',
        sent: 'badge badge-soft-primary',
        warning: 'badge badge-soft-warning',
        deleted: 'badge badge-soft-danger',
        message_processing: 'badge badge-soft-secondary',
        error: 'badge badge-soft-danger',
        processed: 'badge badge-soft-success',
        processing: 'badge badge-soft-warning'
      }[status]

      return color
    },
    getSpanishMessageStatus(messageStatus) {
      const status = {
        read: 'Leído',
        delivered: 'Entregado',
        failed: 'Fallido',
        sent: 'Enviado',
        deleted: 'Eliminado',
        warning: 'Advertencia',
        processed: 'Procesado',
        processing: 'Procesando'
      }[messageStatus]

      return status
    },
  },
  mounted() {
    this['conversation/getMessageDetails']({
      message_id: this.message_id,
      params: {},
      callback: (res) => {
        this.loading_message = false
        this.message = res
      }
    })
  },
  watch: {},
  components: { 'json-view': JsonViewer }
}
</script>

<style lang="scss" scoped>
span {
  display: block;
}
.wrapping {
  display: flex;
  max-width: 218px;
}
.cardToSlice{
  border-color: #d8dde2;
}
.not-collapsed > .collapse-icon {
  transform: rotate(-180deg);
}

.collapse-icon {
  transition: 0.3s;
}

.break {
  max-width: 250px;
  word-wrap: normal;

}
</style>
